import React, { forwardRef } from 'react';
import { cn } from 'cn';
import { Badge as UIBadge } from '@/components/ui/badge';

type BadgeColor =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'success'
  | 'warning'
  | 'info'
  | 'light'
  | 'primaryLight';

const VARIANTS: Record<
  BadgeColor,
  React.ComponentProps<typeof UIBadge>['variant']
> = {
  primary: 'default',
  secondary: 'secondary',
  danger: 'destructive',
  success: 'success',
  warning: 'warning',
  info: 'info',
  light: 'secondary',
  primaryLight: 'defaultLight',
};

type BadgeProps = React.ComponentPropsWithoutRef<'span'> & {
  /** Cor do badge. Sem `color` e com fundo no `style`, o texto fica branco. */
  color?: BadgeColor;
  /** Ignorada: herança do reactstrap. Todo badge já é arredondado. */
  pill?: boolean;
  /** Ignorada: herança do reactstrap. */
  cssModule?: unknown;
};

/**
 * Etiqueta pequena para contagem ou classificação. Vazio, não aparece. Para status com cores fixas (ativo, inativo…), use o `StatusBadge`.
 * @import import Badge from 'src/componentes/Badge';
 */
const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { color, pill, cssModule, className, style, ...rest },
  ref
) {
  const temBgInline = style && (style.background || style.backgroundColor);
  const variant =
    (color && VARIANTS[color]) || (temBgInline ? 'default' : 'secondary');

  return (
    <UIBadge
      ref={ref}
      variant={variant}
      className={cn('tw:empty:hidden', className)}
      style={style}
      {...rest}
    />
  );
});

export default Badge;
